import {
  FETCH_REQUEST_HISTORY_BEGIN,
  FETCH_REQUEST_HISTORY_SUCCESS,
  FETCH_REQUEST_HISTORY_FAILURE,
  HANDLE_FILE_AVAILABLE_CLICK
} from "./types";
import API from "../../../../../Services/API";
import { ENDPOINTS } from "utils/endpoints";

export const fetchRequestHistory = () => async dispatch => {
  dispatch({ type: FETCH_REQUEST_HISTORY_BEGIN });

  try {
    const response = await API({
      method: "POST",
      url: ENDPOINTS.FETCH_REQUEST_HISTORY
    }).catch(err => dispatch({ type: FETCH_REQUEST_HISTORY_FAILURE }));

    if (response && response.data && response.data.hasOwnProperty("elementsData")) {
      dispatch({
        type: FETCH_REQUEST_HISTORY_SUCCESS,
        payload: {
          elementsData: response.data.elementsData,
          agentDetailsData: response.data.agentDetailsData,
          fullNameForWln: response.data.fullNameForWln,
          accountId:response.data.accountId?response.data.accountId:"",
          serviceType:response.data.serviceType?response.data.serviceType:""
        }
      });
    } else {
      dispatch({ type: FETCH_REQUEST_HISTORY_FAILURE });
    }
  } catch (error) {
    dispatch({ type: FETCH_REQUEST_HISTORY_FAILURE });
  }
};


export const fetchFormerRequestHistory = (data) => async dispatch => {
  dispatch({ type: FETCH_REQUEST_HISTORY_BEGIN });
  try {
    var dataToAPI ={
        accountId: data.billingAccountNumber,
    }
      const response = await API({
          method: "POST",
          url: ENDPOINTS.FORMER_FETCH_REQUEST_HISTORY,
          data: dataToAPI
      }).catch(err => dispatch({ type: FETCH_REQUEST_HISTORY_FAILURE }));
      
      if (response && response.data && response.data.hasOwnProperty("elementsData")) {
          dispatch({
              type: FETCH_REQUEST_HISTORY_SUCCESS,
              payload: {
                  elementsData: response.data.elementsData,
                  accountId:response.data.accountId,
                  serviceType:response.data.serviceType
              }
          });
      } else {
          dispatch({ type: FETCH_REQUEST_HISTORY_FAILURE });
      }
  } catch (error) {
      dispatch({ type: FETCH_REQUEST_HISTORY_FAILURE });
  }
};

export const handleFileAvailableClick = item => dispatch => {
  dispatch({
    type: HANDLE_FILE_AVAILABLE_CLICK,
    payload: item
  });
};
